export function cancellable(fn: (isCanceled: () => boolean) => void, cleanup?: () => void) {
    const state = { active: true };
    fn(() => !state.active);
    return () => {
        if (cleanup) cleanup();
        state.active = false;
    };
}
